import { render, staticRenderFns } from "./indexGoods.vue?vue&type=template&id=3fb8e0a6&scoped=true&"
import script from "./indexGoods.vue?vue&type=script&lang=js&"
export * from "./indexGoods.vue?vue&type=script&lang=js&"
import style0 from "./indexGoods.vue?vue&type=style&index=0&id=3fb8e0a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb8e0a6",
  null
  
)

export default component.exports